import {
    AccountSubscriptionType,
    ConstructorViewInfoStatus,
    ProjectDetailDto,
} from "../api/psc";

export const SubscriptionTypesDefintions = [
    {
        type: AccountSubscriptionType.STANDARD,
        title: "بنیان",
        color: "#9848FF",
    },
    {
        type: AccountSubscriptionType.ENHANCED,
        title: "رویان",
        color: "#9848FF",
    },
    {
        type: AccountSubscriptionType.ULTIMATE,
        title: "تابان",
        color: "#9848FF",
    },
    {
        type: AccountSubscriptionType.ULTIMATE_PLUS,
        title: "تابان پلاس",
        color: "#9848FF",
    },
];

export function parseType(type: number): string {
    if (type === 2) {
        return "پروژه های بازاریابی شده";
    } else {
        return "پروژه های عادی";
    }
}

export function getVisitConstructorErrorOrNull(
    projectDetail: ProjectDetailDto
): string | null {
    if (!projectDetail.canVisit) {
        return "اشتراک شما قادر به مشاهده این پروژه نیست";
    }

    if (!projectDetail.hasAvailableConstructor) {
        return "سازنده فعال برای این پروژه در این لحظه یافت نشد";
    }

    return null;
}

export function getAccessErrorMessageOrNull(
    status?: ConstructorViewInfoStatus
): string | null {
    if (!status || status === ConstructorViewInfoStatus.NO_ERROR) {
        return null;
    }

    switch (status) {
        case ConstructorViewInfoStatus.NOT_AVAILABLE:
            return "سازنده در این لحظه قابل مشاهده نیست";
        case ConstructorViewInfoStatus.ACCESS_DENIED:
            return "شما اجازه دسترسی به این پروژه را ندارید";
        case ConstructorViewInfoStatus.LIMIT_EXCEED:
            return "شما قادر به مشاهده سازنده بیش از تعداد مجاز روزانه نمی باشید";
        case ConstructorViewInfoStatus.LIMITED_ACCOUNT:
            return "دسترسی شما به مشاهده سازنده محدود شده است، لطفا با پشتیبانی تماس حاصل نمایید";
        case ConstructorViewInfoStatus.ACCOUNT_FROZEN:
            return "حساب کاربری شما فریز شده است لطفا به بخش تنظیمات پروژه ها مراجعه نمایید";
        case ConstructorViewInfoStatus.NO_CONSTRUCTOR:
            return "سازنده ای برای این پروژه یافت نشد";
    }
}
